import Marquee from "react-fast-marquee";

const ROWS = [
    [
        "Complete beginners",
        "Shower singers",
        "Aspiring artists",
        "Content creators",
        "Teenagers",
        "Adults chasing a lifelong dream",
    ],
    [
        "Birthday gifts",
        "Hen & stag groups",
        "Influencers launching music",
        "First‑time songwriters",
        "Anyone with a song inside them",
    ],
];

export default function WhoItsFor() {
    return (
        <section
            className="relative py-16 md:py-24 overflow-hidden bg-[#1B4D3E] text-white border-y-4 border-black"
            data-testid="who-its-for-section"
        >
            <div className="px-6 md:px-10 max-w-7xl mx-auto reveal mb-8 md:mb-12">
                <h2 className="font-display tracking-tighter font-black leading-[0.95] text-5xl md:text-6xl lg:text-7xl max-w-3xl">
                    Built for <em className="not-italic bg-[#D4A017] text-black px-3 -rotate-1 inline-block">real</em> people.
                </h2>
                <p className="mt-6 text-white/80 text-lg max-w-xl">
                    No music industry experience required. Just the courage
                    to start.
                </p>
            </div>

            <div className="space-y-2 md:space-y-3">
                <Marquee speed={50} gradient gradientColor="#1B4D3E" gradientWidth={120}>
                    {ROWS[0].map((w, i) => (
                        <span
                            key={i}
                            className="font-display font-black tracking-tighter text-[14vw] md:text-[10vw] lg:text-[8.5rem] mx-8 leading-none text-outline-light"
                        >
                            {w} <span className="text-[#D4A017] mx-2">★</span>
                        </span>
                    ))}
                </Marquee>
                <Marquee speed={45} direction="right" gradient gradientColor="#1B4D3E" gradientWidth={120}>
                    {ROWS[1].map((w, i) => (
                        <span
                            key={i}
                            className="font-display font-black tracking-tighter text-[14vw] md:text-[10vw] lg:text-[8.5rem] mx-8 leading-none text-[#D4A017]"
                        >
                            {w} <span className="text-white mx-2">★</span>
                        </span>
                    ))}
                </Marquee>
            </div>
        </section>
    );
}
